import gql from 'graphql-tag';

export const ListPostsQuery = gql`
  query($filter: JSON) {
    Posts(filter: $filter) {
      _id
       isDeleted
      createdAt
      author {
        _id
        username
      }
      image
      tags {
        items {
          tag {
            _id
            title
          }
        }
      }
      likes {
        count
      }
    }
  }
`;

export const PostDetailQuery = gql`
  query($postId: String!) {
    Post(filter:{_id: $postId}) {
      _id
       isDeleted
        author {
        _id
        username
      }
      comments {
        items {
          _id
          message
          author {
            _id
            username
          }
        }
      }
      image
      content
      createdAt
      likes {
        count
      }
      tags {
        items {
          tag {
            _id
            title
          }
        }
      }
    }
  }
`;

export const UpdatePostMutation = gql`
  mutation($id: String!, $update: JSON) {
    updatePost(filter: {_id: $id}, update: $update) {
      _id
      content
      image
      comments {
        items{
          _id
          message
        }
      }
    }
  }
`;

export const PostTagsQuery = gql`
query($filter: JSON) {
  ModelTags(filter: $filter) {
    _id
    title
  }
}
`;

export const CreatePostMutation = gql`
  mutation($record: JSON) {
    createPost(record: $record) {
      _id
    }
  }
`;

export const CreateNewTagMutation = gql`
  mutation($record: JSON) {
    createModelTag(record: $record) {
      _id
      title
    }
  }
`;

export const UpdateCommentMutation = gql`
  mutation($id: String!, $update: JSON) {
    updateComment(filter: {_id: $id}, update: $update) {
      _id
      message
    }
  }
`;

export const CreatePostTagMutation = gql`
  mutation($record: JSON) {
    createPostTag(record: $record) {
      _id
    }
  }
`;

export const DeletePostTagMutation = gql`
  mutation($update: JSON) {
    deletePostTag(query: $update)
  }
`;

export const DeletePostMutation = gql`
  mutation($id: String!) {
    deletePost(query: {_id: $id})
  }
`;

export const DeleteCommentMutation = gql`
  mutation($id: String!) {
    deleteComment(query: {_id: $id})
  }
`;
